import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, AuthContext } from './context/AuthContext';
import { AssessorAuthProvider } from './context/AssessorAuthContext';
import { ThemeProvider } from './context/ThemeContext';
import Dashboard from './components/Dashboard';
import Trainees from './components/Trainees';
import Attendance from './components/Attendance';
import Communication from './components/Communication';
import Analytics from './components/Analytics';
import BatchManagement from './components/BatchManagement';
import ProfileLinks from './components/ProfileLinks';
import AttendanceLink from './components/AttendanceLink';
import ProfileUpdateLink from './components/ProfileUpdateLink';
import Evaluation from './components/Evaluation';
import EvaluationLink from './components/EvaluationLink';
import Assessment from './components/Assessment';
import AssessorDashboard from './components/AssessorDashboard';
import AssessorPrivateRoute from './components/AssessorPrivateRoute';
import Login from './components/Login';
import PrivateRoute from './components/PrivateRoute';
import NotificationContainer from './components/Notification';
import './App.css';

// /admin is the address staff are given for this app's administration: signed in goes to the dashboard, otherwise to the admin sign-in.
const AdminEntry = () => {
  const { user, loading } = useContext(AuthContext);
  if (loading) return null;
  return <Navigate to={user ? '/' : '/login?portal=admin'} replace />;
};

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
      <AssessorAuthProvider>
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<AdminEntry />} />
          <Route path="/attendance/:token" element={<AttendanceLink />} />
          <Route path="/evaluation/:token" element={<EvaluationLink />} />
          <Route path="/profile-update/:token" element={<ProfileUpdateLink />} />
          {/* Legacy links from before the unified login page — keep them working. */}
          <Route path="/assessor-login" element={<Navigate to="/login?portal=assessor" replace />} />
          <Route path="/assessor-login/:token" element={<Navigate to="/login?portal=assessor" replace />} />
          <Route
            path="/assessor/dashboard"
            element={
              <AssessorPrivateRoute>
                <AssessorDashboard />
              </AssessorPrivateRoute>
            }
          />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/trainees"
            element={
              <PrivateRoute>
                <Trainees />
              </PrivateRoute>
            }
          />
          <Route
            path="/attendance"
            element={
              <PrivateRoute>
                <Attendance />
              </PrivateRoute>
            }
          />
          <Route
            path="/communication"
            element={
              <PrivateRoute>
                <Communication />
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics"
            element={
              <PrivateRoute>
                <Analytics />
              </PrivateRoute>
            }
          />
          <Route
            path="/batches"
            element={
              <PrivateRoute>
                <BatchManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/profile-links"
            element={
              <PrivateRoute>
                <ProfileLinks />
              </PrivateRoute>
            }
          />
          <Route
            path="/evaluations"
            element={
              <PrivateRoute>
                <Evaluation />
              </PrivateRoute>
            }
          />
          <Route
            path="/assessment"
            element={
              <PrivateRoute>
                <Assessment />
              </PrivateRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <NotificationContainer />
      </Router>
      </AssessorAuthProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;

